import type { Dictionary } from '../i18n';
import type { useDocumentSound } from './useDocumentSound';

export function DocumentSoundControl({ sound, t }: { sound: ReturnType<typeof useDocumentSound>; t: Dictionary }) {
  const text = t.documentNotifications;
  const ready = !sound.muted && sound.status === 'ready';
  return (
    <div className="row" style={{ justifyContent: 'flex-end', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
      <span className="sm muted" role="status">{sound.status === 'unsupported' ? text.unsupported : sound.muted ? text.muted : text[sound.status]}</span>
      <button type="button" className="btn ghost sm" disabled={sound.status === 'unsupported'} onClick={() => ready ? sound.mute() : void sound.enable()}>
        {ready ? text.mute : text.enable}
      </button>
      {!sound.muted && sound.status === 'blocked' && (
        <button type="button" className="btn ghost sm" onClick={sound.mute}>{text.mute}</button>
      )}
    </div>
  );
}
